import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'models/app-store';
import { applyTheme } from 'utils/apply-theme';

const useInitTheme = (ref: React.MutableRefObject<boolean>): void => {
  const darkMode = useSelector((state: AppState) => state.ui.darkMode);
  const customThemes = useSelector((state: AppState) => state.ui.themes);

  useEffect(() => {
    ref.current = false;
  }, [customThemes]);

  useEffect(() => {
    if (ref.current) {
      return;
    }

    applyTheme(darkMode, customThemes);

    ref.current = true;
  }, [darkMode, customThemes]);
};

export default useInitTheme;
